import { render, staticRenderFns } from "./_public-portal-links.vue?vue&type=template&id=030f8da6"
import script from "./_public-portal-links.vue?vue&type=script&lang=js"
export * from "./_public-portal-links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports